define(function (require, exports) {
    'use strict';

    /**
     * Directive for drawing the Header component
     */
    exports.metHeader = function () {
        return {
            restrict: 'AE',
            scope: {
                iconShow: '@', // To show or not an icon before the text; Boolean, Required
                iconClass: '@', // The Font awesome class name of the icon; String
                iconColor: '@' // To change the color of the icon, hex color (#ffffff); String
            },
            replace: true,
            transclude: true,
            template: '<div class="met-header">' +
            '   <div class="header-icon" ng-show="{{iconShow}}"><i class="fa {{iconClass}}" style="color: {{iconColor}}"></i></div>' +
            '   <div class="header-text">' +
            '       <div ng-transclude></div>' +
            '   </div>' +
            '</div>'
        };
    };

});



// WEBPACK FOOTER //
// ./scripts/directives/metHeader.js